export const resumeParse = {
  url: '/api/v1/candidate/no/required/lhh/resume_parse',
  method: 'POST'
};

export const deliverResume = {
  url: '/api/v1/candidate/no/required/lhh/deliver_resume',
  method: 'POST'
};
